export interface DownloadPageDocumentParams {
  pageType: string;
  pageId: string;
  documentId: string;
  fileName: string;
  /** When set alongside `unitSystem`, the API route treats this as a branded-TDS download. */
  language?: string;
  unitSystem?: 'METRIC' | 'IMPERIAL';
  correlationId: string;
}

/**
 * Downloads a page document via the `/api/page-documents/...` API route.
 * Returns the binary as a Blob, ready to hand to `file-saver`.
 */
export async function downloadPageDocument({ pageType, pageId, documentId, fileName, language, unitSystem, correlationId }: DownloadPageDocumentParams): Promise<Blob> {
  const params = new URLSearchParams({ filename: fileName });
  if (language && unitSystem) {
    params.set('language', language);
    params.set('uom', unitSystem);
  }

  const response = await fetch(`/api/page-documents/${pageType}/${pageId}/${documentId}?${params.toString()}`, {
    headers: { 'x-ravago-correlation-id': correlationId }
  });

  if (!response.ok) throw new Error(`Document download failed with status ${response.status}`);
  return response.blob();
}

/**
 * Downloads the merged product comparison PDF via the `/api/product-compare-documents` API route.
 * Returns the binary as a Blob, ready to hand to `file-saver`.
 */
export async function downloadProductComparisonDocuments(productsUlIds: string[], correlationId: string): Promise<Blob> {
  const params = new URLSearchParams({ ids: productsUlIds.join(',') });

  const response = await fetch(`/api/product-compare-documents?${params.toString()}`, {
    headers: { 'x-ravago-correlation-id': correlationId }
  });

  if (!response.ok) throw new Error(`Product comparison download failed with status ${response.status}`);
  return response.blob();
}
